import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import {
  Grid,
  IconButton,
  Chip,
  Tooltip,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import HelpIcon from "@material-ui/icons/Help";
import { setSelectedReportTag, setSavedSelectedReportTagData, setDrawerTagTip, setAssetComment, setSavedCommentData } from "../../actions";
import _ from "lodash";
import TagConfig from "../../config/TagConfig";
import LocalStorageHelper from "../../utils/helper/localstorage_helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      marginBottom: theme.spacing(2),
      maxWidth: 1200,  // Magnify に合わせた最大幅
      width: '100%',   // 横幅を100%に統一
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    title: {
      fontSize: 12,
      color: "#484848",
    },
    item: {
      marginTop: theme.spacing(1),
    },
    filtered: {
      flex: 1,
      maxWidth: 1200,
      width: '100%',  // 横幅を100%に統一
      position: "relative",
    },
    iconTooltip: {
      fontSize: 18,
      marginTop: -4,
      marginLeft: 4,
    },
    tagSelect: {
      marginTop: theme.spacing(1),
      fontSize: 16,
      minWidth: 600,
      maxWidth: 1000,
      "& .MuiInputLabel-root": {
        fontSize: "16px",
      },
      "& .MuiInputBase-input": {
        fontSize: "16px",
      },
    },
    tagWrapper: {
      display: "flex",
    },
    tagDropdown: {
      marginLeft: -32,
    },
    saveButton: {
      fontWeight: "medium",
      height: 30,
      marginTop: 12,
      marginLeft: 16,
      paddingTop: 8,
    },
    formWrapper: {
      display: "flex",
    },
    form: {
      marginRight: 16,
      width: "85.9%",
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
      },
    },
  })
);

const ReportMeta = ({
  periodType,
  viewer,
  setSelectedReportTag,
  selectedReportTag,
  setSavedSelectedReportTagData,
  tagSavingLoader,
  commentSavingLoader,
  setDrawerTagTip,
  openTagTip,
  setAssetComment,
  setSavedCommentData,
  assetComment,
}) => {
  const classes = useStyles();
  const [tagData, setTagData] = useState(
    TagConfig.reportResultTagTemp2.slice(1)
  );
  const [photoData, setPhotoData] = useState([]);
  const companyName = LocalStorageHelper.getCompany();
  const isNtt = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9";

  useEffect(() => {
    if (viewer.length > 0 && viewer[0].allPhotoUrl) {
      const uniquePhotoData = _.uniqWith(viewer[0].allPhotoUrl, _.isEqual);
      setPhotoData(uniquePhotoData);
    }
  }, [viewer]);

  const handleSelectReportTagChange = (tags) => {
    const savingTagData = {
      report_id: viewer[0].reportId,
      file_name: viewer[0].fileName,
      file_url: viewer[0].fileUrl,
      occurred_datetime: viewer[0].occurred_datetime_jst,
      game_space_id: viewer[0].gameSpaceId,
      power_asset_id: viewer[0].powerAssetId,
      place_code: viewer[0].placeCode,
      sign_number: viewer[0].signNumber,
      equipment_number: viewer[0].name,
      player_id: viewer[0].playerId,
      player_name: viewer[0].user,
      tags: viewer[0].tag,
      result_tags: tags,
    }
    setSelectedReportTag(savingTagData);
  };

  console.log("LOG: viewer[0]:", viewer[0]);
  return (
    <div className={classes.container}>
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        className={classes.filtered}
      >
        {viewer.length > 0 && (
          <>
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                {companyName === "tepco" && `標識番号 | 標識名：`}
                {companyName.includes("ntt") && `県域 | 収容局名 :`}
                {companyName === "hokuden" && `電柱番号 :`}
              </Typography>
              {viewer[0]["signNumber"] !== undefined && companyName === "tepco" &&
                `${viewer[0]["signNumber"]} | ${viewer[0]["signName"]}`
              }
              {viewer[0]["signNumber"] !== undefined && companyName.includes("ntt") &&
                `${viewer[0]["prefecturalArea"]} | ${viewer[0]["exchangeOfficeName"]}`
              }
              {viewer[0]["powerPoleNumber"] !== undefined && companyName === "hokuden" &&
                `${viewer[0]["powerPoleNumber"]}`
              }
            </Grid>
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>
                {/* {!isNtt ? `設備番号 | スキーマ番号：` : `電柱情報 :`} */}
                {companyName === "tepco" && `設備番号 | スキーマ番号：`}
                {companyName.includes("ntt") && `電柱情報 :`}
                {companyName === "hokuden" && `市町村名 :`}
              </Typography>
              {/* {viewer[0]["name"] !== undefined
                ? `${viewer[0]["name"]} | ${viewer[0]["placeCode"]}`
                : isNtt ? `${viewer[0]["assetInfo"]}` : "-"} */}
              {viewer[0]["name"] !== undefined && companyName === "tepco" &&
                `${viewer[0]["name"]} | ${viewer[0]["placeCode"]}`
              }
              {viewer[0]["assetInfo"] !== undefined && companyName.includes("ntt") &&
                `${viewer[0]["assetInfo"]}`
              }
              {viewer[0]["representativeMunicipalityName"] !== undefined && companyName === "hokuden" &&
                `${viewer[0]["representativeMunicipalityName"]}`
              }
            </Grid>
            {companyName.includes("ntt") &&
              <Grid item className={classes.item} xs={4} md={2}>
                <Typography color="textSecondary" style={{ marginLeft: 0 }}>撮影対象：</Typography>
                {viewer[0]["photographyTarget"] !== undefined
                ? `${viewer[0]["photographyTarget"]}`
                : "-"}
              </Grid>
            }
            {companyName === "hokuden" &&
              <Grid item className={classes.item} xs={4} md={2}>
                <Typography color="textSecondary" style={{ marginLeft: 0 }}>支店コード：</Typography>
                {viewer[0]["branchCode"] !== undefined
                ? `${viewer[0]["branchCode"]}`
                : "-"}
              </Grid>
            }
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>撮影点数：</Typography>
              {!viewer[0]["allPhotoUrl"][0] ? "0" : photoData.length}
            </Grid>
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>報告者：</Typography>
              {viewer[0].user}
            </Grid>
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>報告日時：</Typography>
              {viewer[0].occurred_datetime_jst
                ? viewer[0].occurred_datetime_jst.slice(0, 19).replace("T", " ")
                : "-"}
            </Grid>
            {companyName === "tepco" &&
            <Grid item className={classes.item} xs={4} md={2}>
              <Typography color="textSecondary" style={{ marginLeft: 0 }}>高圧設備：</Typography>
              {viewer[0]["withInsulatedSwitch"]
                ? `有`
                : "無"}
            </Grid>
            }
            <Grid item className={classes.item} xs={12} spacing={3} style={{ marginTop: 16 }}>
              <Grid container direction="row" alignItems="flex-start">
                <Grid item lg={6} md={6} xs={12}>
                  <Typography color="textSecondary" style={{ marginLeft: 0, marginBottom: 4 }}>報告タグ：</Typography>
                    {viewer[0].tag.length > 0
                      ?
                      viewer[0].tag.map((tag, index) => (
                        <Tooltip
                          title={viewer[0]["tagDisplay"][index] !== "その他" ? viewer[0]["tagDisplay"][index] : ""}
                          placement="top"
                        >
                          <Chip
                            key={index}
                            style={{
                              backgroundColor: "#ffed6f",
                              color: "black",
                              paddingTop: "0px !important",
                            }}
                            size="small"
                            label={tag}
                          ></Chip>
                        </Tooltip>
                      ))
                      : "-"
                    }
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                  <Typography color="textSecondary" style={{ marginLeft: 0, marginBottom: 4 }}>報告内容：</Typography>
                  {viewer[0].comment ? viewer[0].comment : "-"}
                </Grid>
              </Grid>
            </Grid>
            {viewer[0]["tag"].some(tag => tag.includes("ツルツタ")) &&
            <Grid item className={classes.item} xs={12}>
            <Grid item className={classes.item} xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                className={classes.filtered}
              >
                <Grid item className={classes.item} xs={12} md={6} lg={2}>
                  <div style={{ color: "rgba(0, 0, 0, 0.54)", fontSize: 14 }}>
                    報告確認結果入力
                    {/* <IconButton
                      className={classes.iconTooltip}
                      color="inherit"
                      aria-label="open drawer"
                      onClick={() => setDrawerTagTip(!openTagTip)}
                      disableRipple={true}
                      disableFocusRipple={true}
                    >
                      <HelpIcon
                        fontSize="small"
                      />
                    </IconButton> */}
                  </div>
                </Grid>
                <Grid item className={classes.tagDropdown} xs={12} md={12} lg={8}>
                {tagData !== null && tagData.length > 0 && (
                  <div className={classes.tagWrapper}>
                  <Autocomplete
                    multiple
                    id="tag-select-autocomplete"
                    options={tagData}
                    getOptionLabel={(option) => option.value || ""}
                    getOptionSelected={(option, value) => option.value.toString() === value.toString()}
                    value={selectedReportTag.result_tags !== undefined &&
                          selectedReportTag.result_tags.length > 0
                            ? tagData.filter(tag => selectedReportTag.result_tags.includes(tag.value.toString()))
                            : []}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const selectedValues = newValue.map((tag) => tag.value.toString());
                        console.log("LOG: selectedValues:", selectedValues);
                        handleSelectReportTagChange(selectedValues);
                      } else {
                        handleSelectReportTagChange([]);
                      }
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={index}
                          size="small"
                          label={`${option.label} : ${option.tip}`}
                          {...getTagProps({ index })}
                          style={{ backgroundColor: '#ffed6f', color: 'black' }} // Set Chip color
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={selectedReportTag.tags !== undefined && selectedReportTag.tags.length < 1 ? "選択する" : ""}
                        className={classes.tagSelect}
                      />
                    )}
                    renderOption={(option, { selected }) => {
                      const isFirstOldItem = option.value === "ツルツタLv.0−1";
                      return (
                        <Box
                          width="100%"
                          display="flex"
                          flexDirection="column"
                        >
                          {isFirstOldItem && (
                            <Divider
                              style={{
                                margin: '8px 0',
                                borderTop: '2px solid #aaa',
                                width: '100%',
                              }}
                            />
                          )}
                          <Box
                            pl={option.indent ? 3 : 0} // ← `marginLeft` ではなく `paddingLeft` を Box で指定
                          >
                            <Typography variant="body1">
                              <b>{option.label}</b> : {option.tip}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    }}
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    color="default"
                    className={classes.saveButton}
                    onClick={setSavedSelectedReportTagData}
                  >
                    {tagSavingLoader ? "保存中.." : "保存"}
                  </Button>
                  </div>
                )}
                </Grid>
              </Grid>
            </Grid>
            </Grid>
            }
            {/* <Grid item className={classes.item} xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-start"
                className={classes.filtered}
              >
                <Grid item className={classes.item} xs={12} md={8} lg={9}>
                  <div className={classes.formWrapper}>
                    <form className={classes.form} noValidate autoComplete="off">
                      <TextField
                        id="outlined-multiline-static"
                        multiline
                        defaultValue={assetComment !== "" ? assetComment : ""}
                        variant="outlined"
                        placeholder="コメント入力 (最大400字)"
                        fullWidth
                        inputProps={{ style: { fontSize: 13, marginTop: -8, padding: '2px 4px'  } }}
                        onChange={handleCommentChange}
                      />
                    </form>
                    <Button
                      variant="outlined"
                      size="small"
                      color="default"
                      className={classes.saveButton}
                      style={{ height: '100%', marginLeft: 8 }}
                      onClick={setSavedCommentData}
                    >
                      {commentSavingLoader ? "保存中.." : "保存"}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid> */}
          </>
        )}
      </Grid>
    </div>
  );
};

ReportMeta.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  periodType: state.app.periodType,
  selectedReportTag: state.app.selectedReportTag,
  tagSavingLoader: state.app.tagSavingLoader,
  openTagTip: state.app.openTagTip,
  commentSavingLoader: state.app.commentSavingLoader,
  assetComment: state.app.assetComment,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedReportTag: (param) => dispatch(setSelectedReportTag(param)),
  setSavedSelectedReportTagData: (param) => dispatch(setSavedSelectedReportTagData(param)),
  setDrawerTagTip: (param) => dispatch(setDrawerTagTip(param)),
  setAssetComment: (param) => dispatch(setAssetComment(param)),
  setSavedCommentData: (param) => dispatch(setSavedCommentData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(ReportMeta));
